/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tfield_League_Not_OrganizerInputs */



/**
* | output |
* | --- |
* | "not an organizer" |
*
* @param {Tfield_League_Not_OrganizerInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tfield_league_not_organizer = /** @type {((inputs?: Tfield_League_Not_OrganizerInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tfield_League_Not_OrganizerInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("pas organisateur")
	if (locale === "es") return /** @type {LocalizedString} */ ("no es organizador")
	if (locale === "pt") return /** @type {LocalizedString} */ ("não é organizador")
	if (locale === "it") return /** @type {LocalizedString} */ ("non organizzatore")
	return /** @type {LocalizedString} */ ("not an organizer")
});